<template lang="pug">
    layout
        template(slot="title")

            // Title
            title-component(:title="$t('auth.confirmEmail.title')" type="h1")

            // Message
            div(v-html="$t('auth.confirmEmail.message')")

        // Login form

</template>

<script>
    import Layout from '../Layout';
    import { Title } from '~components';
    import VueTypes from 'vue-types';
    import { auth } from '~api';

    export default {
        components: {
            Layout,
            TitleComponent: Title,
        },
        async beforeRouteEnter(to, from, next) {
            const resp = await auth.confirmEmail({ token: to.query.token });

            if (resp.ok) {
                return next('/dashboard');
            }

            next('/login');
        },
        props: {
            email: VueTypes.string.def(''),
        },
    };
</script>
